export default defineNuxtPlugin(async nuxtApp => {
  const route = useRoute()

  // Wait for app to be mounted to ensure cookie is available
  await nuxtApp.hooks.callHook('app:mounted', nuxtApp.vueApp)

  await useAuth({ path: route.path, fullPath: route.fullPath })
})
